import { z } from 'zod';

import type {
  UpdateShipmentDraftRequest,
  UpdateShipmentDraftResponse,
} from './update-shipment-draft.dto.js';
import {
  ShipmentHeaderSchema,
  ShipmentRangeBuilderInputSchema,
  ShipmentReceiverSelectionSchema,
  ShipmentSourceEvidenceSchema,
  ShipmentTargetBuilderInputSchema,
} from './shipments-shared.schema.js';

const updateShipmentDraftBaseShape = {
  companyId: z.uuid(),
  shipmentId: z.uuid(),
  stationId: z.uuid(),
  receiver: ShipmentReceiverSelectionSchema,
  ...ShipmentSourceEvidenceSchema.shape,
};

const UpdateShipmentDraftRangeSchema = ShipmentRangeBuilderInputSchema.extend(
  updateShipmentDraftBaseShape,
).strict();

const UpdateShipmentDraftTargetSchema = ShipmentTargetBuilderInputSchema.extend(
  updateShipmentDraftBaseShape,
).strict();

export const UpdateShipmentDraftRequestSchema: z.ZodType<UpdateShipmentDraftRequest> = z
  .discriminatedUnion('mode', [UpdateShipmentDraftRangeSchema, UpdateShipmentDraftTargetSchema])
  .superRefine((value, ctx) => {
    const rangeStartMs = Date.parse(value.rangeStartAt);
    const rangeEndMs = Date.parse(value.rangeEndAt);
    if (!Number.isNaN(rangeStartMs) && !Number.isNaN(rangeEndMs) && rangeStartMs >= rangeEndMs) {
      ctx.addIssue({
        code: 'custom',
        message: 'rangeStartAt must be before rangeEndAt.',
        path: ['rangeEndAt'],
      });
    }
    const hasLoadSessionId = value.sourceLoadSessionId !== undefined && value.sourceLoadSessionId !== null;
    const hasGroupId =
      value.sourceLoadSessionGroupId !== undefined && value.sourceLoadSessionGroupId !== null;
    if (hasLoadSessionId !== hasGroupId) {
      ctx.addIssue({
        code: 'custom',
        message: 'sourceLoadSessionId and sourceLoadSessionGroupId must be provided together.',
        path: [hasLoadSessionId ? 'sourceLoadSessionGroupId' : 'sourceLoadSessionId'],
      });
    }
  });

export const UpdateShipmentDraftResponseSchema: z.ZodType<UpdateShipmentDraftResponse> = z
  .object({
    shipment: ShipmentHeaderSchema,
  })
  .strict();
